module.exports = __webpack_public_path__ + "img/fcom.034c74cc.svg";